import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { keyframes } from '@emotion/react';

const pulseAnimation = keyframes`
  0% {
    background-color: rgb(25, 118, 210);
  }
  50% {
    background-color: rgb(76, 175, 80);
  }
  100% {
    background-color: rgb(25, 118, 210);
  }
`;

interface AttentionAddButtonProps {
  hasInput: boolean;
  onClick: () => void;
  fullWidth?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

const AttentionAddButton: React.FC<AttentionAddButtonProps> = ({ 
  hasInput, 
  onClick, 
  fullWidth = false,
  loading = false,
  disabled = false,
}) => {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <AddIcon />}
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      className={hasInput && !loading ? 'pulse' : ''}
      sx={{
        '&.pulse': {
          animation: `${pulseAnimation} 2s infinite`,
          '&:hover': {
            animation: 'none',
            backgroundColor: 'primary.dark'
          }
        }
      }}
    >
      {loading ? 'Adding...' : 'Add'}
    </Button>
  );
};

export default AttentionAddButton;